import { showError } from "../components/ErrorPopup";
import React, { useState, useEffect } from "react";
import { CheckCircleIcon } from "@heroicons/react/solid";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { apiFetch } from "../utils/apiClient";
import Resizer from "react-image-file-resizer";
import { PDFDocument } from "pdf-lib";
import { TrashIcon } from "@heroicons/react/solid";
import { XCircleIcon } from "@heroicons/react/solid";
import UsersList from "../components/UsersList";
import { FilePreviewModal } from "../components/FilePreviewModal";
import { Eye, Paperclip, Plus } from "lucide-react";
import { io } from "socket.io-client";
const socket = io.connect(`${process.env.REACT_APP_API_BASE_URL}`); 

function ReadOnlyInfo({ label, value }) {
  return (
    <div className="min-w-0 py-2">
      <p className="text-[13px] font-semibold uppercase tracking-wide text-slate-600">
        {label}
      </p>
      <p
        className="mt-1 break-words text-[15px] font-medium text-slate-900"
        title={value}
      >
        {value || "—"}
      </p>
    </div>
  );
}

const DemandeProjet = ({ user, enabled, checkGroupDemandeProjet }) => {
  const [isSubmitted, setIsSubmitted] = useState(false); // State to control popup
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState("");
  const [couleur, setcouleur] = useState("");
  const location = useLocation();
  const [errors, setErrors] = useState({});
  const queryParams = new URLSearchParams(location.search);
  const numeroFormulaireParam = queryParams.get("numeroFormulaire");
  const page = queryParams.get("page") || location.state?.page;
  const [selectedForm, setSelectedForm] = useState(
    location.state?.selectedForm || null,
  );
  const [isLoadingSelectedForm, setIsLoadingSelectedForm] = useState(
    Boolean(numeroFormulaireParam),
  );
  const [selectedFormError, setSelectedFormError] = useState("");
  const [isReadOnly, setIsReadOnly] = useState(false);
  const [formId, setFormId] = useState(
      location.state?.selectedForm?._id || null
    );
  const navigate = useNavigate(); // Initialize navigate hook

  // const [showTable, setShowTable] = useState(false);

  const [uploadedFile, setUploadedFile] = useState(null);
  const [filePreviewUrl, setFilePreviewUrl] = useState(null);
  const [fileUploadError, setFileUploadError] = useState("");
  const [showPopup, setShowPopup] = useState(false);

  const [loadingAction, setLoadingAction] = useState(null);

  useEffect(() => {
    if (!numeroFormulaireParam || checkGroupDemandeProjet !== true) {
      return undefined;
    }

    const controller = new AbortController();

    const loadSelectedForm = async () => {
      setIsLoadingSelectedForm(true);
      setSelectedFormError("");

      try {
        const response = await apiFetch(
          `${process.env.REACT_APP_API_BASE_URL}/selectedFormDemandeProjet?numeroFormulaire=${encodeURIComponent(numeroFormulaireParam)}&page=${encodeURIComponent(page || "")}`,
          { signal: controller.signal },
        );
        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.error || data.message);
        }

        setSelectedForm(data);
        setFormId(data._id || null);
      } catch (error) {
        if (error.name !== "AbortError") {
          console.error(
            "Erreur lors du chargement de la demande de projet :",
            error,
          );
          setSelectedFormError(
            error.message || "Impossible de charger la demande de projet.",
          );
        }
      } finally {
        if (!controller.signal.aborted) {
          setIsLoadingSelectedForm(false);
        }
      }
    };

    loadSelectedForm();

    return () => controller.abort();
  }, [numeroFormulaireParam, page, checkGroupDemandeProjet]);

  const handleUserSelect = (user, fieldName) => {
  const newUser = {
    nom: user.displayName,
    email: user.mail,
    userId: user.id,
    matricule: user.employeeId,
  };

  const existingUsers = formData[fieldName] || [];

  // éviter les doublons (optionnel mais conseillé)
  const alreadyExists = existingUsers.some(u => u.userId === newUser.userId);
  if (alreadyExists) return;

  handleChange({
    target: {
      name: fieldName,
      value: [...existingUsers, newUser]
    },
  });
};

const handleRemoveUser = (index, fieldName) => {
  const updated = [...(formData[fieldName] || [])];
  updated.splice(index, 1);

  setFormData({
    ...formData,
    [fieldName]: updated
  });
};

  const handleListeImplicationsChange = (index, field, value) => {
    setFormData((prev) => {
      const updated = [...prev.listeImplications];
      updated[index] = {
        ...updated[index],
        [field]: value,
      };

      return {
        ...prev,
        listeImplications: updated,
      };
    });

    setErrors("");
  };

  const handleAddListeImplications = () => {
    setFormData((prev) => ({
      ...prev,
      listeImplications: [
        ...prev.listeImplications,
        {
          service: "",
          nature: "",
        },
      ],
    }));

    setErrors("");
  };

  const handleDeleteListeImplications = (index) => {
    setFormData((prev) => ({
      ...prev,
      listeImplications: prev.listeImplications.filter((_, i) => i !== index),
    }));
  };

  const base64ToFile = (base64, filename, mimeType) => {
    // Remove the base64 data prefix (if it exists)
    const base64String = base64.split(",")[1]; // Get the part after the comma
    if (!base64String) {
      throw new Error("Invalid base64 string");
    }

    // Decode the base64 string
    const byteCharacters = atob(base64String);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
      const slice = byteCharacters.slice(offset, offset + 1024);
      const byteNumbers = new Array(slice.length);

      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: mimeType });
    const file = new File([blob], filename, { type: mimeType });

    return file;
  };

  const handleFileUpload = async (e) => {
    const MAX_FILE_SIZE_MB = 5;
    const MAX_FILE_SIZE = MAX_FILE_SIZE_MB * 1024 * 1024;

    const file = e.target.files[0];
    if (!file) return;

    const ALLOWED_TYPES = [
      "application/pdf",
      "image/jpeg",
      "image/jpg",
      "image/png",
    ];

    if (!ALLOWED_TYPES.includes(file.type)) {
      setFileUploadError("Formats acceptés : PDF, JPG, JPEG, PNG.");
      return;
    }

    const resizeImage = (file) =>
      new Promise((resolve) => {
        if (!file.type.includes("image")) return resolve(file);

        Resizer.imageFileResizer(
          file,
          1600,
          1600,
          "WEBP",
          70,
          0,
          (uri) => {
            const resizedFile = new File([uri], file.name, {
              type: "image/webp",
            });
            resolve(resizedFile);
          },
          "blob",
          200,
          200,
        );
      });

    const compressPDF = async (file) => {
      if (file.type !== "application/pdf") return file;

      try {
        const arrayBuffer = await file.arrayBuffer();

        const pdfDoc = await PDFDocument.load(arrayBuffer, {
          ignoreEncryption: false,
        });

        const compressedBytes = await pdfDoc.save();
        return new File([compressedBytes], file.name, {
          type: "application/pdf",
        });
      } catch (error) {
        console.error("Erreur lors du traitement du PDF :", error);

        // PDF protégé ou non lisible → on garde le fichier original
        if (
          error?.message?.toLowerCase().includes("encrypted") ||
          error?.message?.toLowerCase().includes("password") ||
          error?.message?.toLowerCase().includes("decrypt")
        ) {
          setFileUploadError(
            "Ce fichier PDF semble être protégé par mot de passe. Vous pouvez tout de même le joindre, puis indiquer le mot de passe dans le champ prévu à cet effet.",
          );
          return file;
        }

        throw new Error(
          "Le fichier PDF n’a pas pu être traité. Veuillez vérifier le document et réessayer.",
        );
      }
    };

    const processFile = async (file) => {
      if (file.type.includes("image")) {
        return await resizeImage(file);
      } else if (file.type === "application/pdf") {
        return await compressPDF(file);
      }
      return file;
    };

    try {
      const processedFile = await processFile(file);

      if (processedFile.size > MAX_FILE_SIZE) {
        setFileUploadError(
          `Le fichier dépasse la taille maximale permise de ${MAX_FILE_SIZE_MB} Mo.`,
        );
        return;
      }

      setFileUploadError("");
      setUploadedFile(processedFile);
      setFilePreviewUrl(URL.createObjectURL(processedFile));

      setFormData((prev) => ({
        ...prev,
        uploadedFile: {
          filename: processedFile.name,
          contentType: processedFile.type,
          data: "",
        },
      }));

      setErrors("");
    } catch (error) {
      console.error(error);
      setFileUploadError(
        error.message ||
          "Une erreur est survenue lors du téléversement du fichier.",
      );
    }
  };

  const handleFileDelete = () => {
    setUploadedFile(null);
    setFilePreviewUrl(null);
    setShowPopup(false);

    const fileInput = document.getElementById("fileUpload");
    if (fileInput) {
      fileInput.value = "";
    }
  };

  const closePopup = () => {
    setShowPopup(false);
  };

  // Function to generate numeroFormulaire
  const generateNumeroFormulaire = () => {
    const date = new Date();
    const yy = date.getFullYear().toString().slice(-2); // Get last two digits of the year
    const mm = String(date.getMonth() + 1).padStart(2, "0"); // Month (0-padded)
    const dd = String(date.getDate()).padStart(2, "0"); // Day (0-padded)
    const randomNumber = Math.floor(1000 + Math.random() * 9000); // Random 4-digit number

    return `CSV-${yy}${mm}${dd}${randomNumber}-DP`;
  };

  const initialFormData = {
    userId: "",
    nom: "",
    lieuTravail: "",
    numeroFormulaire: generateNumeroFormulaire(),

    etatDemande: "Soumis",
    uploadedFile: null,
    dateSoumission: new Date().toISOString().split("T")[0],
    listeImplications: selectedForm?.listeImplications || [
      {
        service: "",
        nature: "",
      },
    ],

    titreProjet: selectedForm?.titreProjet || "",
    descriptionBesoinOperationnel:
      selectedForm?.descriptionBesoinOperationnel || "",
    alignementPlanStrategiqueConseil:
      selectedForm?.alignementPlanStrategiqueConseil || "",
    championProjet: selectedForm?.championProjet || [],
    responsableProjet: selectedForm?.responsableProjet || [],
    estimationBudgetaire: selectedForm?.estimationBudgetaire || "",
    sourcesFinancement: selectedForm?.sourcesFinancement || "",
    chronologieProjet: selectedForm?.chronologieProjet || "",
    priorite: selectedForm?.priorite || "",
    analyseComplete: selectedForm?.analyseComplete || "",
  };
  // console.log("selected Form: ", selectedForm);
  const [formData, setFormData] = useState(initialFormData);



  useEffect(() => {
    if (user) {
      setFormData((prevData) => ({
        ...prevData,
        nom: user.displayName,
        userId: user.id,
        courriel: user.mail,
        matricule: user.employeeId,
        poste: user.jobTitle,
        lieuTravail: user.officeLocation || "",
      }));
    }

    if (selectedForm) {
      if (
        (selectedForm.etatDemande === "Soumis" &&
        page === "Mes taches") || selectedForm.estFerme 
      ) {
        setIsReadOnly(true);
      }

      setFormData((prevData) => ({
        ...prevData,
        userId: selectedForm.userId,
        nom: selectedForm.nom,
        matricule: selectedForm.matricule,
        poste: selectedForm.poste,
        lieuTravail: selectedForm.lieuTravail || "",
        courriel: selectedForm.courriel,
        numeroFormulaire: selectedForm.numeroFormulaire,
        dateSoumission:
          selectedForm.etatDemande === "Brouillon"
            ? new Date().toISOString().split("T")[0]
            : selectedForm.dateSoumission || prevData.dateSoumission,
        etatDemande: selectedForm?.etatDemande || "",

        listeImplications: selectedForm?.listeImplications || [
          {
            service: "",
            nature: "",
          },
        ],
        titreProjet: selectedForm?.titreProjet || "",
        descriptionBesoinOperationnel:
          selectedForm?.descriptionBesoinOperationnel || "",
        alignementPlanStrategiqueConseil:
          selectedForm?.alignementPlanStrategiqueConseil || "",
        championProjet: selectedForm?.championProjet || [],
        responsableProjet: selectedForm?.responsableProjet || [],
        estimationBudgetaire: selectedForm?.estimationBudgetaire || "",
        sourcesFinancement: selectedForm?.sourcesFinancement || "",
        chronologieProjet: selectedForm?.chronologieProjet || "",
        priorite: selectedForm?.priorite || "",
        analyseComplete: selectedForm?.analyseComplete || "",
      }));
    }

    // Prefill dispositions table
    //   if (selectedForm.dispositions && selectedForm.dispositions.length > 0) {
    //     setRows(selectedForm.dispositions); // Populate rows for the table
    //     setFormData((prevData) => ({
    //       ...prevData,
    //       dispositions: selectedForm.dispositions, // Update formData with prefilled dispositions
    //     }));
    //   }
    if (
      selectedForm?.uploadedFile?.data &&
      selectedForm?.uploadedFile?.contentType &&
      selectedForm?.uploadedFile?.filename
    ) {
      const base64String = `data:${selectedForm.uploadedFile.contentType};base64,${selectedForm.uploadedFile.data}`;
      const file = base64ToFile(
        base64String,
        selectedForm.uploadedFile.filename,
        selectedForm.uploadedFile.contentType,
      );

      setUploadedFile(file);
      setFilePreviewUrl(URL.createObjectURL(file));
    }
  }, [user, selectedForm, page]);

  const handleChange = (e) => {
    const { name, type, value, checked } = e.target;

    setErrors(""); // reset errors

    setFormData((prevData) => {
      let updatedData = { ...prevData };

      // ✅ Gestion générique
      updatedData[name] = type === "checkbox" ? checked : value;

      // 🔒 EXCLUSIVITÉ DES CHECKBOXES

      return updatedData;
    });
  };

  const handleFormAction = async (e, actionType) => {
    e.preventDefault();

    // Set dateSoumission to the current date and time in local timezone
    const currentDate = new Date();

    // Set the etatDemande based on the action type
    const updatedFormData = {
      ...formData,
      etatDemande: actionType, // Action type can be either "Soumettre" or "Enregistrer"
      dateSoumission: currentDate, // Send as a Date object
    };

    const method = formId ? "PUT" : "POST"; // Use PUT if selectedForm exists, otherwise POST
    const formType = "DemandeProjet";
    const url = formId
      ? `${process.env.REACT_APP_API_BASE_URL}/formFile/${formId}?form=${formType}` // Use the selectedForm ID to update
      : `${process.env.REACT_APP_API_BASE_URL}/formFile?form=${formType}`; // Use POST for creating a new form

    // console.log("uploadedFile : ", uploadedFile);

    const formDataToSend = new FormData();

    // Append form data fields to FormData (use JSON.stringify for nested objects if needed)
    formDataToSend.append("updatedFormData", JSON.stringify(updatedFormData));
    if (uploadedFile) {
      const blob = new Blob([uploadedFile], { type: uploadedFile.type });
      formDataToSend.append("file", blob, uploadedFile.name);
      // console.log(uploadedFile);
    }
    try {
      const response = await apiFetch(url, {
        method: method,
        body: formDataToSend,
      });
      
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || data.message);
      }
      if(updatedFormData.etatDemande !== "Brouillon"){
          if (socket) {
          socket.emit("requestUpdated");
        }
        }
        setIsSubmitted(true); // Show popup
        // Hide popup after 3 seconds
        await new Promise((resolve) => {
          setTimeout(() => {
            setIsSubmitted(false); // Hide the popup after timeout
            resolve(); // Resolve the promise after 3 seconds
          }, 3000);
        });
        
        // Store the ID if this was a new form
        if (!formId && data.form?._id) {
          setFormId(data.form._id);
        }

        if (
          updatedFormData.etatDemande !== "Brouillon" &&
          updatedFormData.etatDemande !== ""
        ) {
          const initialFormData = {
            nom: user.displayName,
            userId: user.id,
            numeroFormulaire: generateNumeroFormulaire(),
            // declarationAnnuelle: false,
            // rapportPolice: false,
            coupable: "",
            dateDocumentPolice: "",
            declarationExacteEtComplete: "non",
            typeDemande: "",
            typeDocument: "",
            dateDeclaration: new Date().toISOString().split("T")[0] + "",
            etatDemande: "Soumis",
            traitant: [],
            dateSoumission: "",
            dispositions: [],
          };
          setFormData(initialFormData);

          handleFileDelete();
          // setShowTable(false); here
          setErrors("");

          navigate("/demande", { state: { selectedForm: null } });
        }
        
    } catch (error) {
      console.error(error);
      showError(error); // ou setError(error.message)
    }finally {
      setLoadingAction(null);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (loadingAction) return;

  if (!validateForm()) return;

  setLoadingAction("submit");

  handleFormAction(e, "Soumis");
    // console.log(formData)
    setMessage("Succès ! Le formulaire a été soumis.");
    setcouleur("text-green-600");
  };

  const handleSave = (e) => {
   if (loadingAction) return;

  setLoadingAction("save");

  handleFormAction(e, "Brouillon");
    setMessage(
      "Succès ! Le formulaire a été enregistré.\nVeuillez noter que l'enregistrement ne signifie pas que le formulaire a été soumis.",
    );
    setcouleur("text-grey-600");
    setErrors("");
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.nom) newErrors.nom = "Ce champ est requis.";

    if (!formData.courriel) newErrors.courriel = "Ce champ est requis.";

    if (!formData.poste) newErrors.poste = "Ce champ est requis.";

    if (!formData.titreProjet) newErrors.titreProjet = "Ce champ est requis.";

    if (!formData.descriptionBesoinOperationnel) newErrors.descriptionBesoinOperationnel = "Ce champ est requis.";

    if (!formData.alignementPlanStrategiqueConseil) newErrors.alignementPlanStrategiqueConseil = "Ce champ est requis.";

    if (!formData.championProjet || formData.championProjet.length === 0) newErrors.championProjet = "Veuillez sélectionner au moins un champion du projet.";

    if (!formData.responsableProjet || formData.responsableProjet.length === 0 ) newErrors.responsableProjet = "Veuillez sélectionner un responsable du projet.";

    if (!formData.estimationBudgetaire) newErrors.estimationBudgetaire = "Ce champ est requis.";

    if (!formData.sourcesFinancement) newErrors.sourcesFinancement = "Ce champ est requis.";

    if (!formData.chronologieProjet) newErrors.chronologieProjet = "Ce champ est requis.";

    if (!formData.priorite) newErrors.priorite = "Ce champ est requis.";

    if (!formData.analyseComplete) newErrors.analyseComplete = "Ce champ est requis.";

    if (formData.typeDocument !== "" && !uploadedFile) {
      newErrors.uploadedFile = "Le fichier est obligatoire.";
    }

    if (!formData.listeImplications || formData.listeImplications.length === 0) {
    newErrors.listeImplications = "Veuillez ajouter au moins un service.";
  } else {
    formData.listeImplications.forEach((listeImplication, index) => {
      if (!listeImplication.service || listeImplication.service.trim() === "") {
        newErrors[`listeImplications.${index}.service`] = "Veuillez ajouter un service.";
      }

      if (!listeImplication.nature || listeImplication.nature.trim() === "") {
        newErrors[`listeImplications.${index}.nature`] = "Veuillez ajouter une nature.";
      }

    });
  }

    // Add other validations if necessary

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Return true if no errors
  };

  const renderError = (field) => {
    return errors[field] ? (
      <p style={{ color: "red" }}>{errors[field]}</p>
    ) : null;
  };

  /************************** Handle Inputs *******************************/

  if (checkGroupDemandeProjet === null) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-gray-100 p-6">
        <div className="flex items-center gap-3 text-slate-700" role="status">
          <span className="h-8 w-8 animate-spin rounded-full border-4 border-slate-300 border-t-blue-600" />
          <span className="font-medium">Vérification de votre accès...</span>
        </div>
      </div>
    );
  }

  if (!checkGroupDemandeProjet) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center bg-gray-100 p-6 text-center">
        <XCircleIcon className="mb-4 h-16 w-16 text-red-500" />
        <h3 className="mb-2 text-2xl font-bold text-slate-800">
          Accès restreint
        </h3>
        <p className="max-w-md text-gray-700">
          Vous n'avez pas les permissions nécessaires pour accéder au
          formulaire de demande de projet.
        </p>
      </div>
    );
  }

  if (numeroFormulaireParam && isLoadingSelectedForm) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-gray-100 p-6">
        <div className="flex items-center gap-3 text-slate-700" role="status">
          <span className="h-8 w-8 animate-spin rounded-full border-4 border-slate-300 border-t-blue-600" />
          <span className="font-medium">Chargement de la demande...</span>
        </div>
      </div>
    );
  }

  if (numeroFormulaireParam && selectedFormError) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center bg-gray-100 p-6 text-center">
        <XCircleIcon className="mb-4 h-16 w-16 text-red-500" />
        <h3 className="mb-2 text-2xl font-bold text-slate-800">
          Impossible d'ouvrir la demande
        </h3>
        <p className="max-w-md text-gray-700">{selectedFormError}</p>
      </div>
    );
  }

  if (
    (!enabled && !selectedForm) ||
    (!enabled && selectedForm && selectedForm.etatDemande === "Brouillon")
  ) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-6 text-center">
        <XCircleIcon className="h-16 w-16 text-red-500 mb-4 animate-pulse" />
        <h3 className="text-2xl font-bold text-red-600 mb-2">
          Formulaire Demande de Projet fermé
        </h3>
        <p className="text-gray-700 max-w-md">
          Le formulaire est désormais fermé.
        </p>
      </div>
    );
  }
  /************************************************************************/

  return (
    <div className="relative min-h-screen bg-[#f7f7f8] px-4 py-6 sm:px-6 lg:px-8">
      <div className="mx-auto w-full max-w-[1600px]">
      {/* <form
        onSubmit={handleSubmit}
        className="maxn-h-screen p-8 bg-gray-100 rounded-lg shadow-lg"
      > */}
        <dl className="ml-auto grid w-full max-w-md grid-cols-1 rounded-lg border border-gray-200 bg-white text-sm sm:w-fit sm:max-w-none sm:grid-cols-[auto_auto]">
          <div className="min-w-0 px-4 py-3 sm:px-5">
            <dt className="text-xs font-medium text-slate-500">
              Numéro de formulaire
            </dt>
            <dd className="mt-1 break-words font-semibold text-slate-800">
              {formData.numeroFormulaire}
            </dd>
          </div>
          <div className="min-w-0 border-t border-gray-100 px-4 py-3 sm:border-l sm:border-t-0 sm:px-5">
            <dt className="text-xs font-medium text-slate-500">Date</dt>
            <dd className="mt-1 font-medium text-slate-700">
              {formData.dateSoumission
                ? new Intl.DateTimeFormat("fr-CA", {
                    day: "numeric",
                    month: "short",
                    year: "numeric",
                    timeZone: "UTC",
                  }).format(new Date(formData.dateSoumission))
                : "—"}
            </dd>
          </div>
        </dl>

        <div className="my-6 flex w-full justify-center">
          <div className="w-fit max-w-full rounded-lg border border-blue-100 border-l-4 border-l-blue-500 bg-blue-50 px-4 py-3 text-blue-800 shadow-sm">
            <p className="flex items-center gap-2 text-lg font-semibold">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6 text-blue-600"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 17v-2a4 4 0 014-4h6m-6 0V9m0 0H9m3 0h3"
                />
              </svg>
              Demande de projet
            </p>
          </div>
        </div>

        <div className="mt-8 w-full rounded-t-xl bg-gradient-to-r from-[#182a43] to-[#40516a] py-3 shadow-sm">
          <p className="ml-4 flex items-center text-base font-semibold tracking-wide text-white">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 text-blue-400 mr-2"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5.121 17.804A13.937 13.937 0 0112 15c2.21 0 4.27.534 6.121 1.47M15 10a3 3 0 11-6 0 3 3 0 016 0z"
              />
            </svg>
            Information du membre du personnel
          </p>
        </div>

        <div className="mt-5 w-full rounded-xl border border-gray-200 bg-white shadow-sm">
          <div className="p-5 sm:p-6">
            <div className="mb-3">
              <p className="text-sm font-semibold text-gray-800">
                Renseignements du profil
              </p>
              <p className="mt-1 text-[13px] leading-5 text-slate-600">
                Ces informations proviennent de votre compte professionnel.
              </p>
            </div>
            <div className="grid max-w-5xl grid-cols-1 gap-x-10 gap-y-2 sm:grid-cols-2">
              <ReadOnlyInfo label="Nom" value={formData.nom} />
              <ReadOnlyInfo label="Courriel" value={formData.courriel} />
              <ReadOnlyInfo
                label="Lieu de travail"
                value={formData.lieuTravail}
              />
              <ReadOnlyInfo label="Poste" value={formData.poste} />
            </div>
          </div>
        </div>
        <div className="mt-8 w-full rounded-t-xl bg-gradient-to-r from-[#182a43] to-[#40516a] py-3 shadow-sm">
          <p className="ml-4 flex items-center text-base font-semibold tracking-wide text-white">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 text-blue-400 mr-2 flex-shrink-0"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={1.8}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M9 12h6m-6 4h6M9 8h3m-6 12h12a2 2 0 002-2V8.414a2 2 0 00-.586-1.414l-2.414-2.414A2 2 0 0015.586 4H6a2 2 0 00-2 2v12a2 2 0 002 2z"
              />
            </svg>
            Détails du Projet
          </p>
        </div>
        <div className="mt-5 w-full rounded-xl border border-gray-200 bg-white shadow-sm">
          <div className="p-5 sm:p-6">
            <div className="max-w-5xl space-y-6">
        <div className="w-full">
          <div className="w-full">
            <label
              htmlFor="titreProjet"
              className="block text-[15px] font-medium text-slate-700"
            >
              Titre du projet <span className="text-xl text-red-900">*</span>:
            </label>
            <textarea
              className="mt-1.5 w-full resize-y rounded-lg border border-slate-300 bg-white px-3.5 py-3 text-[15px] text-slate-800 shadow-sm outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
              rows="2"
              id="titreProjet"
              name="titreProjet"
              value={formData.titreProjet}
              onChange={handleChange}
              readOnly={isReadOnly}
            />
            {renderError("titreProjet")}
          </div>
        </div>

        <div className="w-full">
          <div className="w-full">
            <label
              htmlFor="descriptionBesoinOperationnel"
              className="block text-[15px] font-medium text-slate-700"
            >
              Description du besoin opérationnel{" "}
              <span className="text-xl text-red-900">*</span>:
            </label>
            <textarea
              className="mt-1.5 w-full resize-y rounded-lg border border-slate-300 bg-white px-3.5 py-3 text-[15px] text-slate-800 shadow-sm outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
              rows="5"
              id="descriptionBesoinOperationnel"
              name="descriptionBesoinOperationnel"
              value={formData.descriptionBesoinOperationnel}
              onChange={handleChange}
              readOnly={isReadOnly}
            />
            {renderError("descriptionBesoinOperationnel")}
          </div>
        </div>
        <div className="w-full">
          <div className="w-full">
            <label
              htmlFor="alignementPlanStrategiqueConseil"
              className="block text-[15px] font-medium text-slate-700"
            >
              Alignement avec le plan stratégique du Conseil{" "}
              <span className="text-xl text-red-900">*</span>: <p className="text-[85%] text-gray-500">Insérez le ou les points applicables du plan stratégique</p>
            </label>
            <textarea
              className="mt-1.5 w-full resize-y rounded-lg border border-slate-300 bg-white px-3.5 py-3 text-[15px] text-slate-800 shadow-sm outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
              rows="2"
              id="alignementPlanStrategiqueConseil"
              name="alignementPlanStrategiqueConseil"
              value={formData.alignementPlanStrategiqueConseil}
              onChange={handleChange}
              readOnly={isReadOnly}
            />
            {renderError("alignementPlanStrategiqueConseil")}
          </div>
        </div>

<div className="grid w-full grid-cols-1 gap-6 lg:grid-cols-2">
<div className="w-full min-w-0">
  <div className="w-full">
    <label className="mb-2 block text-[15px] font-medium text-slate-700">
      Champion/Sponsor du projet <span className="text-xl text-red-900">*</span> :
      <span className="mt-1 block text-[13px] font-normal text-slate-500">
        Membre qui appuie le projet
      </span>
    </label>
    { (page !== "Mes taches" && selectedForm?.estFerme !== true) && (
    <div className="relative">
      <UsersList onUserSelect={(user) => handleUserSelect(user, "championProjet")} isRequired={false}/>

    </div>)}
{renderError("championProjet")}
    <div className="flex flex-wrap gap-2 mt-3">
      {formData.championProjet?.map((user, index) => (
        <div
          key={index}
          className="flex items-center gap-2 bg-blue-800 text-white px-3 py-1 rounded-full text-md"
        >
          {user.nom}
          {(page !== "Mes taches" && selectedForm?.estFerme !== true)  && (
          <button
            type="button"
            onClick={() => handleRemoveUser(index, "championProjet")}
            className="ml-1 text-white hover:text-blue-200"
          >
            ✕
          </button>)}
        </div>
      ))}
    </div>
  </div>
</div>



<div className="w-full min-w-0">
  <div className="w-full">
    <label className="mb-2 block text-[15px] font-medium text-slate-700">
      Responsable du projet <span className="text-xl text-red-900">*</span> :
      <span className="mt-1 block text-[13px] font-normal text-slate-500">
        Personne redevable de la réussite du projet
      </span>
    </label>
{(page !== "Mes taches" && selectedForm?.estFerme !== true)  && (
    <div className="relative">
      <UsersList onUserSelect={(user) => handleUserSelect(user, "responsableProjet")} isRequired={false} />
    </div>)}
      {renderError("responsableProjet")}
    <div className="flex flex-wrap gap-2 mt-3">
      {formData.responsableProjet?.map((user, index) => (
        <div
          key={index}
          className="flex items-center gap-2 bg-green-800 text-white px-3 py-1 rounded-full text-md"
        >
          {user.nom}
          {(page !== "Mes taches" && selectedForm?.estFerme !== true)  && (
          <button
            type="button"
            onClick={() => handleRemoveUser(index, "responsableProjet")}
            className="ml-1 text-white hover:text-green-200"
          >
            ✕
          </button>)}
        </div>
      ))}
    </div>
  </div>
</div>
</div>

        {/* Conditional Table */}
<p className="mb-4 text-sm font-semibold text-slate-800">
  Parties prenantes clés : services, secteurs et écoles impliqués
</p>

        <div className="overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm">
          <div className="hidden overflow-x-auto sm:block">
          <table className="w-full text-md">
            <thead className="bg-slate-100 text-slate-700">
              <tr>
                <th className="px-4 py-3 text-left w-[30%]">
                  Services/secteurs/écoles
                </th>
                <th className="px-4 py-3 text-left w-[30%]">
                  Nature de l’implication
                </th>
                <th className="px-4 py-3 text-center w-[2%]">Action</th>
              </tr>
            </thead>

            <tbody className="divide-y divide-gray-100">
              {formData.listeImplications?.map((item, index) => (
                <tr key={index} className="hover:bg-blue-50/40 transition">
                  {/* SERVICES */}
                  <td className="px-4 py-3">
                    <textarea
                      rows={2}
                      placeholder="Saisir (Services/secteurs/écoles)..."
                      readOnly={isReadOnly}
                      className="w-full resize-y rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
                      value={item.service || ""}
                      onChange={(e) =>
                        handleListeImplicationsChange(
                          index,
                          "service",
                          e.target.value,
                        )
                      }
                    />
                    {renderError(`listeImplications.${index}.service`)}
                  </td>

                  {/* NATURE */}
                  <td className="px-4 py-3">
                    <textarea
                      rows={2}
                      placeholder="Saisir la nature de l’implication..."
                      readOnly={isReadOnly}
                      className="w-full resize-y rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
                      value={item.nature || ""}
                      onChange={(e) =>
                        handleListeImplicationsChange(
                          index,
                          "nature",
                          e.target.value,
                        )
                      }
                    />
                    {renderError(`listeImplications.${index}.nature`)}
                  </td>

                  {/* ACTION */}
                  <td className="px-4 py-3 text-center">
                    {(page !== "Mes taches" && selectedForm?.estFerme !== true)  && (
                    <button
                      type="button"
                      onClick={() => handleDeleteListeImplications(index)}
                      readOnly={isReadOnly}
                      className="inline-flex items-center justify-center p-2 rounded-xl
          hover:bg-red-50 active:scale-95 transition group"
                    >
                      <TrashIcon className="w-5 h-5 text-red-500 group-hover:text-red-600 transition" />
                    </button>)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>

          <div className="divide-y divide-slate-200 sm:hidden">
            {formData.listeImplications?.map((item, index) => (
              <div key={index} className="space-y-4 p-4">
                <div>
                  <label className="mb-1.5 block text-sm font-medium text-slate-700">
                    Services / secteurs / écoles
                  </label>
                  <textarea
                    rows={2}
                    placeholder="Saisir le service, secteur ou l’école..."
                    readOnly={isReadOnly}
                    className="w-full resize-y rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
                    value={item.service || ""}
                    onChange={(event) =>
                      handleListeImplicationsChange(
                        index,
                        "service",
                        event.target.value,
                      )
                    }
                  />
                  {renderError(`listeImplications.${index}.service`)}
                </div>
                <div>
                  <label className="mb-1.5 block text-sm font-medium text-slate-700">
                    Nature de l’implication
                  </label>
                  <textarea
                    rows={2}
                    placeholder="Saisir la nature de l’implication..."
                    readOnly={isReadOnly}
                    className="w-full resize-y rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
                    value={item.nature || ""}
                    onChange={(event) =>
                      handleListeImplicationsChange(
                        index,
                        "nature",
                        event.target.value,
                      )
                    }
                  />
                  {renderError(`listeImplications.${index}.nature`)}
                </div>
                {page !== "Mes taches" && selectedForm?.estFerme !== true && (
                  <button
                    type="button"
                    onClick={() => handleDeleteListeImplications(index)}
                    className="inline-flex min-h-10 items-center justify-center gap-2 rounded-lg border border-red-200 bg-white px-3 py-2 text-sm font-medium text-red-600 transition hover:bg-red-50"
                  >
                    <TrashIcon className="h-4 w-4" />
                    Supprimer
                  </button>
                )}
              </div>
            ))}
          </div>
          {page !== "Mes taches" && selectedForm?.estFerme !== true && (
            <button
              type="button"
              onClick={handleAddListeImplications}
              className="flex min-h-[42px] w-full items-center justify-start gap-2 border-t border-blue-200 bg-blue-50/60 px-6 py-2 text-sm font-semibold text-blue-600 transition-colors hover:bg-blue-100 hover:text-blue-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-blue-500"
            >
              <Plus size={16} aria-hidden="true" className="shrink-0" />
              Ajouter
            </button>
          )}
        </div>
        {renderError("listeImplications")}

        <div className="grid w-full grid-cols-1 gap-5 sm:grid-cols-2 sm:gap-6">
          <div className="min-w-0">
            <label
              htmlFor="estimationBudgetaire"
              className="block text-[15px] font-medium text-slate-700"
            >
              Estimation budgétaire{" "}
              <span className="text-xl text-red-900">*</span>:
            </label>
            <textarea
              className="mt-1.5 w-full resize-y rounded-lg border border-slate-300 bg-white px-3.5 py-3 text-[15px] text-slate-800 shadow-sm outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
              rows="2"
              id="estimationBudgetaire"
              name="estimationBudgetaire"
              value={formData.estimationBudgetaire}
              onChange={handleChange}
              readOnly={isReadOnly}
            />
            {renderError("estimationBudgetaire")}
          </div>
          <div className="min-w-0">
            <label
              htmlFor="sourcesFinancement"
              className="block text-[15px] font-medium text-slate-700"
            >
              Sources de financement{" "}
              <span className="text-xl text-red-900">*</span>:
            </label>
            <textarea
              className="mt-1.5 w-full resize-y rounded-lg border border-slate-300 bg-white px-3.5 py-3 text-[15px] text-slate-800 shadow-sm outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
              rows="2"
              id="sourcesFinancement"
              name="sourcesFinancement"
              value={formData.sourcesFinancement}
              onChange={handleChange}
              readOnly={isReadOnly}
            />
            {renderError("sourcesFinancement")}
          </div>
        </div>

        <div className="w-full">
          <div className="w-full">
            <label
              htmlFor="chronologieProjet"
              className="block text-[15px] font-medium text-slate-700"
            >
              Chronologie du projet{" "}
              <span className="text-xl text-red-900">*</span>:
            </label>
            <textarea
              className="mt-1.5 w-full resize-y rounded-lg border border-slate-300 bg-white px-3.5 py-3 text-[15px] text-slate-800 shadow-sm outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
              rows="3"
              id="chronologieProjet"
              name="chronologieProjet"
              value={formData.chronologieProjet}
              onChange={handleChange}
              readOnly={isReadOnly}
            />
            {renderError("chronologieProjet")}
          </div>
        </div>

        <div className="grid w-full grid-cols-1 gap-5 sm:grid-cols-2 sm:gap-6">
          <div className="min-w-0">
            <label
              htmlFor="priorite"
              className="block text-[15px] font-medium text-slate-700"
            >
              Priorité <span className="text-xl text-red-900">*</span> :
            </label>
            <select
              id="priorite"
              name="priorite"
              value={formData.priorite}
              onChange={handleChange}
              disabled={isReadOnly}
              className="mt-1.5 w-full rounded-lg border border-slate-300 bg-white px-3.5 py-3 text-[15px] text-slate-800 shadow-sm outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
            >
              <option value="">— Séléctionner —</option>
              <option value="Bas">Bas</option>

              <option value="Moyen">Moyen</option>

              <option value="Haut">Haut</option>
            </select>
            {renderError("priorite")}
          </div>
          <div className="min-w-0">
            <label
              htmlFor="analyseComplete"
              className="block text-[15px] font-medium text-slate-700"
            >
              Analyse à compléter{" "}
              <span className="text-xl text-red-900">*</span> :
            </label>
            <select
              id="analyseComplete"
              name="analyseComplete"
              value={formData.analyseComplete}
              disabled={isReadOnly}
              onChange={handleChange}
              className="mt-1.5 w-full rounded-lg border border-slate-300 bg-white px-3.5 py-3 text-[15px] text-slate-800 shadow-sm outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
            >
              <option value="">— Séléctionner —</option>
              <option value="Aucune">Aucune</option>

              <option value="Cas d’affaires">Cas d’affaires</option>

              <option value="Charte de projet">
                Charte de projet
              </option>
            </select>
            {renderError("analyseComplete")}
          </div>
        </div>

        {/* <div className="mt-5 w-3/4 grid grid-cols-2 gap-0 pt-[1.5%]">
                    <div className="w-3/5 ">
                        <label
                            htmlFor="dateDocumentPolice"
                            className="block text-sm font-medium text-blue-900"
                        >

                            Date
                            <span className="text-xl text-red-900"> *</span>
                        </label>
                        <input
                            type="date"
                            id="dateDocumentPolice"
                            name="dateDocumentPolice"
                            value={formData.dateDocumentPolice}
                            onChange={handleChange}
                            min={new Date(
                                new Date().setMonth(new Date().getMonth() - 6)
                            )
                                .toISOString()
                                .split("T")[0]}
                            max={new Date().toISOString().split("T")[0]}
                            className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200" />
                        {renderError("dateDocumentPolice")}
                    </div>

                </div> */}

        <div className="grid w-full grid-cols-1 gap-5 sm:grid-cols-2 sm:gap-6">
          <div className="min-w-0">
          <label
            htmlFor="fileUpload"
            className="mb-2 block text-sm font-medium leading-5 text-slate-700"
          >
            Fichier<span className="ml-1 text-red-500">*</span> :
          </label>

          {page !== "Mes taches" && selectedForm?.estFerme !== true && (
            <div>
              <div className="relative block w-full">
                <input
                  type="file"
                  id="fileUpload"
                  name="fileUpload"
                  accept=".pdf,.jpg,.jpeg,.png"
                  onChange={handleFileUpload}
                  className="absolute inset-0 cursor-pointer opacity-0"
                  disabled={isReadOnly}
                />
                <button
                  type="button"
                  className="flex h-11 w-full cursor-pointer items-center justify-center gap-2 rounded-lg border border-blue-500 bg-white px-5 text-sm font-medium text-blue-700 shadow-sm transition hover:bg-blue-50 focus:outline-none focus:ring-2 focus:ring-blue-200"
                >
                  <Paperclip className="h-4 w-4" />
                  Joindre un fichier
                </button>
              </div>
              <p className="mt-1 text-xs text-gray-500">
                Formats acceptés : PDF, JPG, JPEG, PNG.
              </p>
            </div>
          )}

          {renderError("uploadedFile")}
          {fileUploadError && (
            <p className="mt-2 text-sm text-red-600">{fileUploadError}</p>
          )}

          {uploadedFile && (
            <div className="mt-3 flex w-full flex-wrap items-center gap-3 rounded-xl border border-slate-200 border-l-4 border-l-slate-400 bg-white p-2.5 shadow-sm transition hover:border-slate-300 hover:bg-slate-50 sm:flex-nowrap">
              <span className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-lg border border-slate-200 bg-slate-100 text-sm">
                {uploadedFile.type?.startsWith("image/") ? "🖼️" : "📄"}
              </span>

              <button
                type="button"
                onClick={() => setShowPopup(true)}
                className="group flex min-w-0 flex-1 items-center gap-3 rounded-lg p-1 text-left outline-none focus-visible:ring-2 focus-visible:ring-blue-200"
              >
                <span className="min-w-0 flex-1">
                  <span className="block truncate text-sm font-medium text-slate-800 group-hover:text-slate-950">
                    {uploadedFile.name}
                  </span>
                  <span className="block text-xs text-slate-500">
                    Cliquer pour visualiser
                  </span>
                </span>
                <span className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-lg bg-slate-100 text-slate-600 transition group-hover:bg-slate-200">
                  <Eye className="h-4 w-4" />
                </span>
              </button>

              {page !== "Mes taches" && selectedForm?.estFerme !== true && (
                <button
                  type="button"
                  onClick={handleFileDelete}
                  className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-lg border border-red-200 bg-white text-red-600 shadow-sm transition hover:border-red-300 hover:bg-red-50 focus:outline-none focus:ring-2 focus:ring-red-100"
                  aria-label="Supprimer le fichier"
                  title="Supprimer le fichier"
                >
                  <TrashIcon className="h-4 w-4" />
                </button>
              )}
            </div>
          )}
          </div>
        </div>
            </div>
          </div>
        </div>

        {showPopup && uploadedFile && (
          <FilePreviewModal
            selectedFile={uploadedFile}
            fileUrl={filePreviewUrl}
            onClose={closePopup}
          />
        )}

        {/* Privacy Statement */}
  
          <div className="mt-6 flex justify-start">
            {/* Left-aligned Buttons */}
            <div className="flex w-full flex-col gap-3 sm:w-auto sm:flex-row">
              {/* Save Button */}
              {/* Reset Button */}
              {/* {(selectedForm?.etatDemande !== "Soumis") && (
            <button
              type="button"
              onClick={handleClear}
              className="mt-5 w-24 py-2 bg-red-600 hover:bg-red-400 text-white rounded-md"
            >
              Réinitialiser
            </button>)} */}

              {selectedForm?.etatDemande !== "Soumis" && (
                <button
                  type="button"
                  onClick={handleSave}
                  disabled={loadingAction !== null}
                  className={`
                    flex w-full items-center justify-center gap-2 sm:w-auto
                    px-5 py-2.5 rounded-xl text-sm font-medium
                    transition-all duration-200
                    shadow-sm
                    ${
                      loadingAction
                        ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                        : "bg-gray-700 text-white hover:bg-gray-600 active:scale-95"
                    }
                    `}
                >
                  {/* {isSubmitting && (
                    <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                    )} */}
                  {loadingAction === "save" && (
                    <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                  )}
                  Enregistrer
                </button>
              )}

              {/* Soumettre */}
              { (page !== "Mes taches" && selectedForm?.estFerme !== true) &&(
              <button
                type="button"
              onClick={handleSubmit}
                disabled={loadingAction !== null}
                className={`
                    flex w-full items-center justify-center gap-2 sm:w-auto
                    px-5 py-2.5 rounded-xl text-sm font-medium
                    transition-all duration-200
                    shadow-sm
                    ${
                      loadingAction
                        ? "bg-green-300 text-white cursor-not-allowed"
                        : "bg-green-600 text-white hover:bg-green-500 active:scale-95"
                    }
                `}
              >
                {loadingAction === "submit" && (
                  <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                )}
                Soumettre
              </button>)}

            </div>
          </div>
        
        {/* </>)} */}
      {/* </form> */}
      </div>
      {isSubmitted && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-30">
          <div
            className={`flex items-center space-x-3 px-5 py-4 bg-white ${couleur} rounded-lg shadow-xl transform transition-all duration-500 ease-in-out animate-bounce`}
          >
            <CheckCircleIcon className={`h-8 w-8 ${couleur} animate-pulse`} />
            <span className="text-lg font-semibold">{message}</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default DemandeProjet;
